export default "__VITE_ASSET__DsbKvqsV__"